module.exports = __webpack_public_path__ + "static/media/5.b8b0e8f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/5.jpg
// module id = 1737
// module chunks = 0